import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const auth = useAuth();

  const signOutRedirect = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('refresh_token');
    sessionStorage.clear(); // optional
    const clientId = "2ap6gqa4acmorhb3mo2qbrircp";
    const logoutUri = "https://discovery.quantecsystems.com/logged-out";
    const cognitoDomain = "https://us-east-1m75y2musr.auth.us-east-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  if (auth.isLoading) {
    return <div>Loading authentication...</div>;
  }

  if (auth.error) {
    return <div>Error: {auth.error.message}</div>;
  }

  return (
    <nav className="navbar">
      <Link className={location.pathname === '/' ? 'active' : ''} to="/">Home</Link>
      <Link className={location.pathname === '/admin' ? 'active' : ''} to="/admin">Admin Panel</Link>
      <Link className={location.pathname === '/dashboard' ? 'active' : ''} to="/dashboard">Dashboard</Link>

      <div style={{ marginLeft: 'auto' }}>
        {auth.isAuthenticated ? (
          <>
            <span style={{ marginRight: '10px' }}>Hi, {auth.user?.profile?.email}</span>
            <button onClick={() => signOutRedirect()}>Sign out</button>
          </>
        ) : (
          <button onClick={() => auth.signinRedirect()}>Sign in</button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
